import { GetterTree } from 'vuex';
import { LoginState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<LoginState, RootState> = {
  selectedChannel(state, getters) {
    return state.selectedChannel;
  },
  isLoginSuccess(state, getters) {
    return state.success;
  },
};

export default getters;
